<template lang="pug">
  .answers-validatin__feed-search
    .form-item__block(v-click-outside="close")
      Input.width-100(
        placeholder="Поиск "
        v-model="search"
        @clear="clearInput"
      )
      SlideUpDown.select__slider(
        v-if="isOpen"
        :duration="slideDuration"
        :style="styles"
        :active="isOpen"
      )
        .select__field.-no-padding-
          .select__item.justify-start(
            v-for="(item, idx) in data" :key="idx"
            @click="setOption(item)"
          )
            template(v-if="item")
              Avatar(circle size="s" :img="item.avatar")
              p.select__text {{item.email}}

</template>
<script>
import SlideUpDown from 'vue-slide-up-down';
import vClickOutside from 'v-click-outside';
import replaceMultipleRouteQuery from '@/functions/replaceMultipleRouteQuery';
import { mapActions, mapState } from 'vuex';

export default {
  directives: { clickOutside: vClickOutside.directive },
  components: { SlideUpDown },
  props: ['value', 'taskInfo', 'courseId'],
  data: () => ({
    search: '',
    userId: '',
    isOpen: false,
    list: '',
    isChoosing: false,
    slideDuration: 200
  }),
  computed: {
    ...mapState('users', {
      data: s => s.data.users
    }),
    styles() {
      if (this.data.length > 0) {
        return { display: 'block' };
      } else {
        return { display: 'none' };
      }
    }
  },
  watch: {
    search(val) {
      this.$emit('input', val);
      if (val.length > 0 && !this.isChoosing) {
        this.isOpen = true;
        this.searchMethodsSolo(val);
      } else if (val.length === 0 && !this.isChoosing) {
        this.isOpen = false;
        this.userId = '';
      } else if (this.isChoosing && val.length > 0) {
        this.isOpen = false;
        this.isChoosing = false;
      }
    },
    userId(val) {
      replaceMultipleRouteQuery([
        {
          value: val,
          name: 'userId',
          method: 'replace'
        },
        {
          value: this.search,
          name: 'name',
          method: 'replace'
        }
      ]);
    },
    '$route.query.userId'(val, oldVal) {
      this.isOpen = false;
      if (val !== oldVal && this.taskInfo) {
        this.getFeedTasks(this.taskInfo);
      } else {
        this.searchFeedTaskEmail({ courseId: this.courseId });
      }
    }
  },
  mounted() {
    this.checkingTaskInfo();
    if (this.search) {
      this.getUsers();
    }
  },
  methods: {
    ...mapActions('answersValidatingFeed', [
      'searchFeedTaskUsers',
      'searchFeedTaskEmail',
      'getFeedTasks'
    ]),
    ...mapActions('users', ['getUsers', 'searchMethodsSolo']),
    close() {
      this.isOpen = false;
    },
    setOption(item) {
      this.isOpen = false;
      this.userId = item.id;
      this.search = item.email;
      this.$emit('change', { userID: this.userId, search: this.search });
    },
    checkingTaskInfo() {
      if (this.$route.query.userId && this.$route.query.name) {
        this.isChoosing = true;
        this.search = this.$route.query.name;
      }
    },
    clearInput() {
      this.userId = undefined;
      this.search = '';
    }
  }
};
</script>
